import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    // 帮助中心
    path: '/mini/help-center',
    name: 'miniHelpCenter',
    component: () =>
      import(/* webpackChunkName: "miniHelpCenter" */ '@/views/mini/help-center/HelpCenter.vue'),
    meta: {
      cname: '帮助中心'
    }
  },
  {
    // 隐私权保护协议-我的车钥匙
    path: '/mini/keyprotocol-pricacy',
    name: 'keyProtocolPricacy',
    component: () =>
      import(/* webpackChunkName: "keyProtocolPricacy" */ '@/views/mini/agreement/UserPrivacy.vue')
  },
  // 我的车钥匙小程序用户协议
  {
    path: '/mini/keyprotocol-user',
    name: 'keyProtocolUser',
    component: () =>
      import(/* webpackChunkName: "keyProtocolUser" */ '@/views/mini/agreement/UserService.vue'),
    meta: {
      cname: '用户服务协议'
    }
  },
  {
    // 帮助中心
    path: '/mini/qa-detail',
    name: 'miniQaDetail',
    component: () =>
      import(/* webpackChunkName: "miniQaDetail" */ '@/views/mini/help-center/QaDetail.vue'),
    meta: {
      cname: '帮助中心'
    }
  }
];
export default routes;
